module.exports = __webpack_public_path__ + "media/images/icons/bookmark-f0280dd17388e21692b2b054799381a2.svg";